export const apiUrl = 'https://api.tacom.srv.br/';
export const praca = 'ctd';
export const apiLoginUrl = 'https://apigw.tacom.srv.br/authentication/v1/auth2/login';
export const username = 'ctd-citsoa@viacaocatedral.com.br';
export const password = 'Pd1Tg@VZs0';

export const versaoSoftware = '4.4.16';
export const idioma = 'pt_BR'

export default {
}